import { render } from "./CheckoutButton.vue?vue&type=template&id=1156d46b&scoped=true"
import script from "./CheckoutButton.vue?vue&type=script&lang=js"
export * from "./CheckoutButton.vue?vue&type=script&lang=js"

import "./CheckoutButton.vue?vue&type=style&index=0&id=1156d46b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1156d46b"]])

export default __exports__